import type {ReactElement} from 'react';
import React from 'react';
import {useAppSelector} from '@/hooks';
import {PosterEditorWebBottomBarButton} from '@Components/poster-editor/components/poster-editor-web-bottom-bar-button/poster-editor-web-bottom-bar-button';
import {PosterEditorWebBottomBar} from '@Components/poster-editor/components/poster-editor-web-bottom-bar';

export function PosterEditorWebBottomBarWrapper(): ReactElement | null {
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });
  
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  if (isVersionHistoryModeActive) {
    return null;
  }

  if (isTimelineModeActive) {
    return <PosterEditorWebBottomBar />;
  }

  return <PosterEditorWebBottomBarButton />;
}
